import { isPlatformBrowser } from '@angular/common';
import { Injectable, signal, inject, PLATFORM_ID } from '@angular/core';

import { MeUser, UserDataStore } from '@app/security/data-access/user/user.types';

@Injectable({ providedIn: 'root' })
export class UserDetailsStorageService {
  private readonly USER_KEY = 'userDetails';
  private platformId = inject(PLATFORM_ID);
  private readonly userSignal = signal<MeUser | null>(isPlatformBrowser(this.platformId) ? this.getStoredUser() : null);

  readonly user = this.userSignal.asReadonly();

  setUserDetails(user: MeUser): void {
    const data: UserDataStore = {
      userDetails: user,
      timestamp: new Date().getTime(),
    };
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.USER_KEY, JSON.stringify(data));
    }
    this.userSignal.set(user);
  }

  clearUserDetails(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(this.USER_KEY);
    }
    this.userSignal.set(null);
  }

  private getStoredUser(): MeUser | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    const data = localStorage.getItem(this.USER_KEY);
    if (!data) return null;
    const { userDetails } = JSON.parse(data) as UserDataStore;
    return userDetails;
  }
}
